$.fn.ajaxPostToolbar = function(result_container_selector, load_more_selector) {
  let self = this

  $(result_container_selector).siblings(load_more_selector).click(function() {
    self.find('input[name=paged]').val(parseInt(self.find('input[name=paged]').val())+1);
    self.submit();
  });

  self.find('select').change(function() {
    if (site_l10n.site_id == '1' && $(this).attr('name') == 'taxonomy_style') {
      window.location.href = $(this).val() + '#realisations';
    } else if (site_l10n.site_id == '1' && $(this).attr('name') == 'taxonomy_blog_category') {
      window.location.href = $(this).val();
    } else {
      self.find('input[name=paged]').val(1);
      self.submit();
    }
  });

  self.find('.ajax-post-toolbar__search input').change(function() {
    self.find('input[name=paged]').val(1);
  });

  return function() {
    self.submit(function(){
      $(result_container_selector).siblings(load_more_selector).addClass('loading');
  		$.ajax({
  			url:self.attr('action'),
  			data:self.serialize(), // form data
  			type:self.attr('method'), // POST
  			beforeSend:function(xhr){
          if(parseInt(self.find('input[name=paged]').val()) <= 1){
            $(result_container_selector).addClass('loading-new-results');
          }
  			},
  			success:function(data){
          if(parseInt(self.find('input[name=paged]').val()) > 1){
            $(data).appendTo($(result_container_selector));
          }else{
            $(result_container_selector).html(data);
            $(result_container_selector).removeClass('loading-new-results');
          }
          if(data.indexOf('<span class="ajax-end"></span>') != -1){
            $(result_container_selector).siblings(load_more_selector).hide();
          }else{
            $(result_container_selector).siblings(load_more_selector).show();
          }
          $(result_container_selector).siblings(load_more_selector).removeClass('loading');
  			}
  		});
  		return false;
  	});
    return self
  }()
};
